import classNames from 'classnames';
import { FC, ReactNode } from 'react';

export interface TextIconButtonProps {
  id?: string;
  className?: string;
  e2e: string;
  iconName: string;
  isDisabled?: boolean;
  onClick?: () => void;
  label?: ReactNode;
  labelPosition?: 'before' | 'after';
}

export const TextIconButton: FC<TextIconButtonProps> = ({
  id,
  iconName,
  onClick,
  isDisabled,
  className,
  e2e,
  labelPosition = 'before',
  label,
}) => {
  const classPosition = labelPosition === 'before' ? 'btn-icon-end' : 'btn-icon-start';

  return (
    <button
      id={id}
      className={classNames(`btn btn-lg btn-flat `, className, classPosition)}
      data-e2e={e2e}
      disabled={isDisabled}
      onClick={onClick}
    >
      {labelPosition === 'before' && label}
      <i className="icon">{iconName}</i>
      {labelPosition === 'after' && label}
    </button>
  );
};

TextIconButton.displayName = 'TextIconButton';
